export default __webpack_public_path__ + "static/media/Spezia.553a824a.jpg";